/*
 * State shared by the profile modal and its sub-modals (password, account
 * deletion): switching modals remounts the profile form, so what the user
 * typed is kept here until the form comes back.
 */

// what the user typed in the profile form, consumed when the form remounts
export const useProfileDraft = () =>
  useState<Record<string, unknown> | undefined>('profileDraft')

// the message shown on the profile form when a sub-modal hands back
export const useProfileFlash = () => useState<string>('profileFlash', () => '')

// A Google sign-up chooses its password before its account is finalized:
// kept here and saved with the profile, when the sign-up is finalized
export const usePendingPassword = () =>
  useState<{ first: string; second: string } | undefined>('pendingPassword')
